import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { DateQueryModel } from '../../Forms/models/date-query.model';

@Injectable()
export class CachedDateService {

    protected cachedSelectedDate: DateQueryModel = null;
    protected cachedSelectedDate$: BehaviorSubject<DateQueryModel> = new BehaviorSubject<DateQueryModel>(null);

    constructor() {}

    setCachedSelectedDate(date: DateQueryModel): void {
        this.cachedSelectedDate = date;
        this.cachedSelectedDate$.next(this.cachedSelectedDate);
    }

    getCachedSelectedDate(): Observable<DateQueryModel> {
        return this.cachedSelectedDate$;
    }
}
